import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { MaterialLoader } from 'components/loaders'
import { Modal } from 'components/layout'
import { ButtonGroup, Button, Title } from 'components/misc'
import { modal } from 'redux/modules/app'

import styles from './utils.styl'

@connect(
  ({ auth, app }) => ({
    refreshingToken: auth.refreshingToken,
    noApiConnection: app.misc.noApiConnection,
  }),
  { modal }
)
class Utils extends Component {
  static propTypes = {
    modal: PropTypes.func,
    refreshPage: PropTypes.bool,
    noApiConnection: PropTypes.bool,
    refreshingToken: PropTypes.bool,
  }

  state = {
    refreshPage: false,
    noApiConnection: false,
  }

  componentDidMount() {
    if (this.props.noApiConnection && !this.state.noApiConnection) {
      this.setNoApiConnection()
    }
  }

  componentWillReceiveProps = nextProps => {
    const { refreshPage, noApiConnection } = this.props

    if (!refreshPage && nextProps.refreshPage) {
      this.handleReload()
    }

    if (!noApiConnection && nextProps.noApiConnection) {
      this.setNoApiConnection()
    }
  }

  setNoApiConnection = () => {
    this.setState(
      {
        noApiConnection: true,
      },
      () => {
        this.props.modal('modal-no-api-connection')
      }
    )
  }

  handleReload = () => {
    this.setState(
      {
        refreshPage: true,
      },
      () => {
        location.reload()
      }
    )
  }

  render() {
    const { refreshPage, noApiConnection } = this.state
    const { refreshingToken } = this.props

    if (!refreshPage && !refreshingToken && !noApiConnection) {
      return null
    }

    return (
      <div>
        {refreshingToken && (
          <div className={styles.reloader}>
            <div className={styles.reloadNote}>
              <div className="base-margin--bottom">
                <FormattedMessage
                  id="label.content_restore"
                  defaultMessage="Refreshing session..."
                />
              </div>
              <MaterialLoader size={60} />
            </div>
          </div>
        )}

        {noApiConnection && (
          <Modal id="modal-no-api-connection" customActions>
            <div className="base-margin text--center">
              <span className="ico ico--sad" style={{ color: '#A7A9AC', fontSize: 52 }} />
              <Title intlKey="moduleTitle.server_is_unreachable" h2>
                Server is unreachable
              </Title>
              <div className="base-margin--bottom">
                <p style={{ fontSize: '1.5em' }}>
                  <FormattedMessage
                    id="error.server_cannot_be_reached_at_the_moment"
                    defaultMessage=" Server cannot be reached at the moment. Please try again
                  later. If the problem persists, please contact our support
                  team."
                  />
                </p>
              </div>
              <ButtonGroup center>
                <Button
                  type="button"
                  intlKey="button.reload_page"
                  onClick={this.handleReload}
                >
                  Reload page
                </Button>
              </ButtonGroup>
            </div>
          </Modal>
        )}
      </div>
    )
  }
}

export default Utils
